import { render, staticRenderFns } from "./SearchBarResult.vue?vue&type=template&id=a08b620c"
import script from "./SearchBarResult.vue?vue&type=script&lang=js"
export * from "./SearchBarResult.vue?vue&type=script&lang=js"
import style0 from "./SearchBarResult.vue?vue&type=style&index=0&id=a08b620c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports